import validateForm from './validateForm';
import displayConfirmation from './displayConfirmation';

export default () => {
  // Submit event for [data-validate-form]
  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-validate-form]')) {
      e.preventDefault();
      const form = e.target;
      const formSuccess = validateForm(form, e);

      // Quick fix for spam on ambassador
      if (form && form.classList.contains('AmbassadorForm')) {
        if (form.querySelector('#Form__Address').value === 'Praia') {
          return false;
        }
      }

      if (formSuccess) {
        displayConfirmation(form);
      }
    }

    // Submit event for [data-validate-shopify-form]
    if (e.target.matches('[data-validate-shopify-form]')) {
      e.preventDefault();
      const form = e.target;
      validateForm(form, e);
      // Submit event requested by reset password page
      if (e.target.matches('.ResetPassword__form')) {
        form.submit();
      }
    }
  });

  // Keyup and change events for [data-validate-form] and [data-validate-shopify-form]
  document.addEventListener('keyup', function (e) {
    if (
      e.target.matches('[data-validate-form] .input-error') ||
      e.target.matches('[data-validate-shopify-form] .input-error')
    ) {
      const form = e.target.closest('[data-validate-form], [data-validate-shopify-form]');
      validateForm(form);
    }
  });

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('[data-validate-form] .input-error') ||
      e.target.matches('[data-validate-shopify-form] .input-error')
    ) {
      const form = e.target.closest('[data-validate-form], [data-validate-shopify-form]');
      validateForm(form);
    }
  });
};
